import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'
import select from './select.vue'

Vue.component('app-usuario-grid', grid)
Vue.component('app-usuario-edit', edit)
Vue.component('app-usuario-select', select)
